<template>
  <div
    v-show="message"
    class="flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
    role="alert"
  >

    {{ message }}

  </div>
</template>

<script>
export default {
  props: ['message']
}
</script>
